// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadItemsList_wrapper__2sZxc","item":"DownloadItemsList_item__lmu6e","label":"DownloadItemsList_label__r+r64"};